import { extendTheme } from '../../../theme';
import defaultTheme from '../../../theme/default-theme';
import { Accordion, ActionBar, Alert, AttentionMessage, ActivityFeed, ActivityItem, ActivityStartItem, Button, Heading, Text, Checkbox, Radio, Menu, Input, InfoBanner, Textarea, WarningBanner, SearchInput, Select, Steps, SuccessBanner, Form, FormError, FormLabel, NumberInput, IconButton, DatePicker, DetailsCard, ErrorBanner, Pagination, Tabs, Table, Switch, Badge, ListItemRow, Card, Link, UnderlineButton, Footer, Header, LogoWrapper } from './components';
import { Colors } from './colors';
import foundations from './foundations';
var theme = extendTheme(defaultTheme, {
  name: 'TQ',
  colors: Colors,
  fonts: {
    heading: foundations.fonts.heading,
    body: foundations.fonts.body
  },
  components: {
    Accordion,
    ActionBar,
    Alert,
    AttentionMessage,
    ActivityFeed,
    ActivityItem,
    ActivityStartItem,
    Checkbox,
    Button,
    Heading,
    Text,
    Radio,
    Menu,
    SearchInput,
    Select,
    Steps,
    SuccessBanner,
    Input,
    InfoBanner,
    Textarea,
    WarningBanner,
    Form,
    FormError,
    FormLabel,
    NumberInput,
    IconButton,
    DatePicker,
    DetailsCard,
    ErrorBanner,
    Pagination,
    Tabs,
    Table,
    Switch,
    Badge,
    ListItemRow,
    Card,
    Link,
    UnderlineButton,
    Footer,
    Header,
    LogoWrapper
  },
  textStyles: foundations.textStyles
});
export default theme;